<template>
    <eg-modal :show="show" @close="$emit('close', false)">
        <h4 class="center" slot="header">Rejeição de solicitação</h4>
        <p slot="body">Tem certeza que você quer apagar essa solicitação?</p>
        <div slot="footer">
            <a @click="$emit('close', false)" id="negative-answer" class="modal-action modal-close btn blue accent-1"
                >Não</a
            >
            <a id="positive-answer" class="modal-action btn blue darken-4" @click="removeRequest">Sim</a>
        </div>
    </eg-modal>
</template>

<script>
import { removeQuotationRequestConfirm } from '@/services/api/quotation';
export default {
    props: { requestId: Number },
    name: 'RemoveQuotationRequestConfirm',
    data() {
        return {
            show: false
        };
    },
    methods: {
        async removeRequest() {
            await removeQuotationRequestConfirm(this.requestId);
        }
    }
};
</script>

<style></style>
